import { defineStore } from 'pinia';
import type { EnvProps } from '~~/server/api/envProps';

export default defineStore('envPropsStore', {
  state: () => <{ envProps: EnvProps }>(<unknown>{
      envProps: null,
    }),
});
